import React, { useEffect, useRef, useState } from 'react';
import { IProject } from '../../interfaces';
import './Project.css';
import ProjectButton from './ProjectButton';


function Project(props: IProject) {
    const [backgroundImage, setBackgroundImage] = useState(null);
    const projectRef = useRef(null);

    useEffect(() => {
        // Dynamically import background image
        if (props.backgroundImage) {
            setBackgroundImage(require('../../images/' + props.backgroundImage))
        } else {
            const numBetweeen1And4 = Math.floor(Math.random() * (4 - 1 + 1) + 1)
            const randomBackground = "bg-" + numBetweeen1And4 + ".webp"
            setBackgroundImage(require('../../images/' + randomBackground))
        }
    }, [props.backgroundImage])

    useEffect(() => {
        // Initialize IntersectionObserver to animate on scroll
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('show')
                }
            })
        })

        // Observe project container, to check if it's in view or not
        if (projectRef.current) observer.observe(projectRef.current)
    }, [])

    const projectBorder = {
        border: "2px " + props.mainColor + " solid",
        borderRadius: "16px"
    }

    const dateStyles = {
        border: "2px " + props.mainColor + " solid",
        color: props.buttonBackgroundColor && props.buttonBackgroundColor !== "#fff" ? props.buttonBackgroundColor : props.mainColor
    }

    const projectBackground = {
        backgroundImage: `url(${backgroundImage})`
    }

    let projectButtons;
    if (props.websiteLink && props.githubLink) {
        projectButtons = <div>
            <ProjectButton link={props.githubLink} buttonBackgroundColor={props.buttonBackgroundColor} buttonTextColor={props.buttonTextColor} mainColor={props.mainColor} buttonText={props.buttonText} type="github"></ProjectButton>
            <ProjectButton link={props.websiteLink} buttonBackgroundColor={props.buttonBackgroundColor} buttonTextColor={props.buttonTextColor} mainColor={props.mainColor} buttonText={props.buttonText} type="website"></ProjectButton>
        </div>
    }
    else if (props.githubLink) {
        projectButtons = <ProjectButton link={props.githubLink} buttonTextColor={props.buttonTextColor} buttonBackgroundColor={props.buttonBackgroundColor} mainColor={props.mainColor} buttonText={props.buttonText} type="github"></ProjectButton>
    }

    return (
        <div className='project-container' ref={projectRef}>
            <div className='project-bg' style={projectBackground}></div>
            <div className="project" style={projectBorder}>
                <div className="date">
                    <p style={dateStyles}>{props.date}</p>
                </div>
                <div className="inner-project" style={projectBorder}>
                    <h2 className='project-name'>{props.name}</h2>
                    <p className="project-text">{props.description}</p>
                </div>

                {projectButtons}
            </div>

        </div >
    );
}

export default Project;